import { STORE_ITEMS } from '../actions/items';

const items = (state = [], action) => {
  switch (action.type) {
    case STORE_ITEMS: {
      const newState = [...action.items];
      return newState;
    }

    default:
      return state;
  }
};

export default items;
